import { types, Instance } from 'mobx-state-tree';
const { model, string, identifierNumber, maybeNull, array, boolean, maybe } = types;

export const UserEditRequestModel = model('UserEditRequestModel', {
  id: identifierNumber,
  email: string,
  fullName: string,
  status: string,
  description: string,
  date: maybeNull(string),
  address: maybeNull(string),
  read: boolean,
  displayName: maybeNull(string),
});
export const NewEditUserRequestModel = model('NewEditUserRequestModel', {
  id: identifierNumber,
  email: string,
  fullName: string,
  uid: string,
  phone: string,
  department: string,
  // role: string,
  group: string,
  status: string,
  description: string,
  createdAt: maybeNull(string),
  read: boolean,
  displayName: maybeNull(string),
});

export type IUserEditRequestModel = Instance<typeof UserEditRequestModel>;
export type INewEditUserRequest = Instance<typeof NewEditUserRequestModel>;
export const UserChangeModelObj = model('UserChangeModel', {
  id: identifierNumber,
  field: string,
  oldValue: string,
  newValue: maybeNull(string),
  status: string,
});

const CustomAttributeModel = model({
  Field: model({
    label: string,
    oldValue: maybeNull(string),
    newValue: maybeNull(string),
    options: maybe(array(string)),
    status: string,
    type: string,
  }),
});

export const UserChangeModel = model('UserChangeModel', {
  id: identifierNumber,
  field: string,
  oldValue: maybeNull(string),
  newValue: maybeNull(string),
  status: maybeNull(string),
  customAttributes: maybe(array(CustomAttributeModel)),
});

export type IUserChangeModel = Instance<typeof UserChangeModel>;

export const UserChangeFormDetailModel = model('UserChangeFormDetailModel', {
  userId: maybeNull(identifierNumber),
  address: maybeNull(string),
  firstName: maybeNull(string),
  lastName: maybeNull(string),
  phone: maybeNull(string),
  title: maybeNull(string),
});
export type IUserChangeFormDetailModel = Instance<typeof UserChangeFormDetailModel>;

export const ArryOfIdsModel = model('ArryOfIdsModel', {
  ids: array(string),
});
export type IArryOfIdsModel = Instance<typeof ArryOfIdsModel>;

export const UserRequestFormModel = model('UserRequestFormModel', {
  id: identifierNumber,
  email: string,
  fullName: string,
  description: string,
  date: string,
});

export type IUserRequestFormModel = Instance<typeof UserRequestFormModel>;
export interface IUserRequestForm {
  id: number;
  email: string;
  fullName: string;
  description: string;
  date: string;
}
